import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import davana from '../../../images/Menu/davana.svg';

import allNames from '../../../constants/allNames.json';

import * as constants from '../../../constants/constants';

import {
  claimHoliday,
} from '../../../actions/member';

class HolidayModals extends React.PureComponent {
    static propTypes = {
      firstName: PropTypes.string,
      birthday: PropTypes.number,
      t: PropTypes.func.isRequired,
      claimHolidayFunc: PropTypes.func.isRequired,
      todayHolidays: PropTypes.shape(),
      claimedRewards: PropTypes.shape(),
      claimedRewardsFetched: PropTypes.bool,
      newVersion: PropTypes.string,
      tutorialShown: PropTypes.bool,
      run: PropTypes.bool,
      toggleHolidayModal: PropTypes.func.isRequired,
      openModal: PropTypes.bool,
      fontMode: PropTypes.string,
    //  nameDayClaimClicked: PropTypes.bool,
    //  birthdayClaimClicked: PropTypes.bool,
    //  holidayClaimClicked: PropTypes.bool,
      holidayTest: PropTypes.bool,
      selectedTestHoliday: PropTypes.shape({}),
      cancelHolidayTest: PropTypes.func.isRequired,
    }

    static defaultProps = {
      firstName: null,
      birthday: null,
      todayHolidays: {},
      claimedRewards: {},
      claimedRewardsFetched: null,
      newVersion: '',
      tutorialShown: false,
      run: false,
      openModal: false,
      fontMode: constants.FONT_MODE.normal,
      holidayTest: false,
      selectedTestHoliday: null,
    }

    constructor(props) {
      super(props);
      const today = new Date();

      let month = today.getMonth() + 1;
      let date = today.getDate();

      if (month < 10) {
        month = `0${month}`;
      }
      if (date < 10) {
        date = `0${date}`;
      }

      let birthdayDate;
      let birthdayMonth;
      if (props.birthday) {
        const birthdayObject = new Date(props.birthday);
        birthdayDate = birthdayObject.getDate();
        birthdayMonth = birthdayObject.getMonth() + 1;
        if (birthdayDate < 10) {
          birthdayDate = `0${birthdayDate}`;
        }
        if (birthdayMonth < 10) {
          birthdayMonth = `0${birthdayMonth}`;
        }
      }

      this.state = {
        year: today.getFullYear(),
        month,
        date,
        birthdayDate,
        birthdayMonth,
        holidays: {
          newYear: '01-01',
          easter: '04-20',
          '4May': '05-04',
          ligo: '06-23',
          jani: '06-24',
          '1September': '09-01',
          lacplesa: '11-11',
          '18November': '11-18',
          christmas: '12-24',
          christmas2: '12-25',
          oldYear: '12-31',
        },
      };
    }

    componentDidMount() {
      this.checkIfHolidayModalOpen();
    }

    componentDidUpdate() {
      this.checkIfHolidayModalOpen();
    }

    checkIfHolidayModalOpen = () => {
      const {
        birthdayClaimClicked, holidayClaimClicked, nameDayClaimClicked, date, month, holidays, year, birthdayDate, birthdayMonth,
      } = this.state;
      const {
        todayHolidays, firstName, claimedRewards, newVerison, toggleHolidayModal,
      } = this.props;

      if (
        (!birthdayClaimClicked && birthdayDate && birthdayDate === date && birthdayMonth === month && (!claimedRewards || !claimedRewards.birthday || claimedRewards.birthday < Date.now() - (1000 * 60 * 60 * 24 * 365)))
          || (!holidayClaimClicked && todayHolidays && todayHolidays.holiday && holidays[todayHolidays.holiday] && holidays[todayHolidays.holiday] === `${month}-${date}` && (!claimedRewards || !claimedRewards.holiday || claimedRewards.holiday !== `${year}-${month}-${date}`))
          || (!nameDayClaimClicked && month === 5 && date === 22 && firstName && ((todayHolidays.names && todayHolidays.names.includes(firstName)) || (firstName && allNames && !allNames.includes(firstName))))
          || (!nameDayClaimClicked && todayHolidays && firstName && todayHolidays.names && todayHolidays.names.includes(firstName) && (!claimedRewards || !claimedRewards.nameDay || claimedRewards.nameDay < Date.now() - (1000 * 60 * 60 * 24 * 365)))
      ) {
        toggleHolidayModal(true);
      }
    }

    claimHoliday = (type) => {
      const { claimHolidayFunc, toggleHolidayModal } = this.props;
      toggleHolidayModal(false);
      claimHolidayFunc(type);

      console.log('claimHoliday', type);

      if (type === 'birthday') {
        this.setState({ birthdayClaimClicked: true });
      } else if (type === 'nameDay') {
        this.setState({ nameDayClaimClicked: true });
      } else if (type === 'holiday') {
        this.setState({ holidayClaimClicked: true }); 
      }
    }

    getHolidayText = (todayHolidays) => {
      const { t } = this.props;
      return `${t(todayHolidays.holiday)} ${t('coinsGift')}`;
    }

    getTestHolidayText = (testHolidays) => {
      const { t } = this.props;
      return `${t(testHolidays.id)} ${t('coinsGift')}`;
    }

    claimTestHoliday = (type) => {
      const { cancelHolidayTest, claimHolidayFunc } = this.props;
      cancelHolidayTest();
      const holidayTestOption = true;
      claimHolidayFunc(type, holidayTestOption);
    }

    render() {
      const {
        holidayTest, selectedTestHoliday, todayHolidays, firstName, t, claimedRewards, claimedRewardsFetched, tutorialShown, run, newVersion, openModal, fontMode,
      } = this.props;
      const {
        year, month, date, holidays, nameDayClaimClicked, birthdayClaimClicked, holidayClaimClicked, birthdayDate, birthdayMonth,
      } = this.state;

      console.log(holidayTest, selectedTestHoliday, "checkTestHoliday", todayHolidays, holidayClaimClicked, );

      if (newVersion && newVersion >= constants.NEW_VERSION && !openModal) {
        if (claimedRewardsFetched && !birthdayClaimClicked && birthdayDate && birthdayDate === date && birthdayMonth === month && (!claimedRewards || !claimedRewards.birthday || claimedRewards.birthday < Date.now() - (1000 * 60 * 60 * 24 * 365))) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('birthday')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button className="holiday-modal-footer-button" color="primary" onClick={() => this.claimHoliday('birthday')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }

        if (!holidayClaimClicked && todayHolidays && todayHolidays.holiday && holidays[todayHolidays.holiday] && holidays[todayHolidays.holiday] === `${month}-${date}` && (!claimedRewards || !claimedRewards.holiday || claimedRewards.holiday !== `${year}-${month}-${date}`)) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {this.getHolidayText(todayHolidays)}
                  {/* {t('holiday', { holiday: t(todayHolidays.holiday) })} */}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={() => this.claimHoliday('holiday')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }

        {/*
        if (!nameDayClaimClicked && firstName && ((todayHolidays.names && todayHolidays.names.includes(firstName)) || (firstName && allNames && !allNames.includes(firstName)))) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('nameDay')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={() => this.claimHoliday('nameDay')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        } */}

        if (!nameDayClaimClicked && todayHolidays && firstName && todayHolidays.names && todayHolidays.names.includes(firstName) && (!claimedRewards || !claimedRewards.nameDay || claimedRewards.nameDay < Date.now() - (1000 * 60 * 60 * 24 * 365))) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('nameDay')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={() => this.claimHoliday('nameDay')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
      }
      if (holidayTest) {
        if (selectedTestHoliday.id === constants.BIRTHDAY_HOLIDAY) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('birthday')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button className="holiday-modal-footer-button" color="primary" onClick={() => this.claimTestHoliday('birthday')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        } else if (selectedTestHoliday.id === constants.NAMEDAY_HOLIDAY) {
          return (
            <Modal container={'div > div'} isOpen size="lg" className={`holiday-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('nameDay')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={() => this.claimTestHoliday('nameDay')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        } else if (constants.PUB_HOLIDAYS.includes(selectedTestHoliday.id)) {
          return (
            <Modal style={{ width: '575px' }} container={'div > div'} isOpen size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {this.getTestHolidayText(selectedTestHoliday)}
                  {/* {t('holiday', { holiday: t(todayHolidays.holiday) })} */}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={() => this.claimTestHoliday('holiday')}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
      }
      return null;
    }
}

const mapStateToProps = state => ({
  firstName: state.member.firstName || null,
  birthday: state.member.birthday || null,
  todayHolidays: state.member.todayHolidays || null,
  claimedRewards: state.member.claimedRewards || null,
  claimedRewardsFetched: state.member.claimedRewardsFetched || false,
  newVersion: state.member.newVersion,
  tutorialShown: state.member.tutorialShown,
});

const mapDispatchToProps = {
  claimHolidayFunc: claimHoliday,
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('holiday')(HolidayModals));
